export const STORAGE_KEY = 'particles-shaders-params'
export const FOLDERS_KEY = 'particles-shaders-folders'
export const PRESETS_KEY = 'particles-shaders-presets'

export const defaultParams = {
    // Appearance
    particleSize: 0.033,
    particleShape: 0,
    shapeSoftness: 0.7,
    particleColor: '#00ffcc',
    colorShift: '#0044ff',
    backgroundColor: '#010a0f',
    opacityVariance: 1.53,
    colorVariance: 2.18,
    sizeVariance: 2.09,
    flashIntensity: 5.9,
    dimIntensity: 1.43,
    saturation: 1.0,
    // Flow field
    flowInfluence: 0.5,
    flowStrength: 2,
    flowFrequency: 0.5,
    // Mouse
    mouseRadius: 10,
    mouseAspect: 3.0,
    suckStrength: 30.0,
    alwaysSuck: false,
    windStrength: 5.0,
    mouseTrail: 0,
    revealEnabled: false,
    revealRadius: 4,
    revealSoftness: 0.6,
    // Particles
    particleCount: 20000,
    respawnRate: 0.3,
    // Physics
    damping: 2.2,
    turbulenceStrength: 3.5,
    turbulenceFrequency: 1.8,
    // Camera
    enableZoom: true,
    enablePan: true,
    enableRotate: true,
    autoRotate: false,
    autoRotateSpeed: 3.7,
    // Bloom
    bloomEnabled: true,
    bloomStrength: 0.72,
    bloomRadius: 0.33,
    bloomThreshold: 0.33,
    // Trail
    trailEnabled: true,
    trailAmount: 33.7,
    trailResolutionScale: 0.75,
    trailBlurAmount: 0.5,
    trailBrightPersist: 0.6,
    trailBlendMode: 0,
    // Depth of field
    dofEnabled: true,
    dofFocus: 18.0,
    dofAperture: 0.15,
    dofMaxBlur: 1.5,
    // HDR
    toneMapping: 4,
    exposure: 1.0,
    // Shape
    shape: 'text',
    shapeText: 'SMOKE',
    shapeScale: 1.0,
    // Morph
    morphEnabled: false,
    morphTarget: 'sphere',
    morphSpeed: 0.5,
    morphStrength: 5.0,
}
